import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import Breadcrumb from "../components/common/Breadcrumb";
import Banner from '../components/workflow/Banner';
import WorkflowReportMenu from '../components/workflow/WorkflowReportMenu';
import Select from 'react-select'
import DetailsPopup from '../components/workflow/DetailsPopup'
import { MenuProvider } from '../components/workflow/MenuContext';
import {
  getWorkkflowCombinations
  , getActualPredictedForecastResults
  , getTopOneModelResults
  , getForecastResults
} from '../services/ApiManageWorkflow'
import {  upsertRecord, deleteRecord } from "../services/IndexedDBUtil";
import { DATABASE_NAME, STORE_NAME } from '../services/constants'
import { displayMessage } from '../Utils/helper';

function WorkflowDetails() {
  const { state } = useLocation();
  const [showWFDetailsModal, setShowWFDetailsModal] = useState(false);
  const [combinations, setCombinations] = useState([]);

  const [selectedCombination, setSelectedCombination] = useState({product:null, location:null});

  useEffect(() => {
    const init = async () => {
      try{
          const [combinations, data1, data2,data3] = await Promise.all(
            [
              getWorkkflowCombinations(state?.workflow?.workflow_id)
             , getActualPredictedForecastResults(state?.workflow?.workflow_id)
             , getTopOneModelResults(state?.workflow?.workflow_id)
             ,getForecastResults(state?.workflow?.workflow_id)
            ]
          )
          setCombinations(combinations);
           // Save  ActualPredicted, TopOneModel, ForecastResults
                await deleteRecord(DATABASE_NAME, STORE_NAME,"WFActualPredictedData");
                await deleteRecord(DATABASE_NAME, STORE_NAME,"WFModelResult");
                await deleteRecord(DATABASE_NAME, STORE_NAME,"WFForecastResult");

                await upsertRecord(DATABASE_NAME, STORE_NAME, {
                  id: "WFActualPredictedData",
                  data: data1,
                });
                await upsertRecord(DATABASE_NAME, STORE_NAME, {
                  id: "WFModelResult",
                  data: data2,
                });
                await upsertRecord(DATABASE_NAME, STORE_NAME, {
                  id: "WFForecastResult",
                  data: data3,
                });
                console.log("success");
      }catch(err){
        await deleteRecord(DATABASE_NAME, STORE_NAME,"WFActualPredictedData");
        await deleteRecord(DATABASE_NAME, STORE_NAME,"WFModelResult");
        await deleteRecord(DATABASE_NAME, STORE_NAME,"WFForecastResult");
        console.error(`Error while fetching data : ${err}`);
      }
    }
    init();
  }, [])
  // const data = await getWorkkflowCombinations(state?.workflow?.workflow_id);
  // //       console.log(data)
  // if (data !== null) {
  //   setCombinations(data)
  // } else {
  //   setCombinations([])
  // }


  if (!combinations) {
    return false;
  }

  function getFormattedPath(obj) {
    let levels = ["level1", "level2", "level3", "level4", "level5"];
    let path = [];

    for (let key of levels) {
      if (!obj[key]) break;  // Stop if value is empty or null
      path.push(obj[key]);
    }

    return path.join("/");
  }

  const options = combinations.map(ob => ({
    label: `${ob.sku_name} - ${getFormattedPath(ob)}`,
    value: {
      sku_name: ob.sku_name,
      location: getFormattedPath(ob),
      sku_id: ob.sku_id
    }
  }))

  const formatOptionLabel = (data, { context }) => {
    return context === "menu" ? <div>
      <span>{data.label}</span>
    </div>
      : <>{data.label}</>
  };

  const combinationSelectChangeHandler = async (selected) => {
    try {
      console.log(selected);
      let obj = { product : selected.value.sku_name, location: selected.value.location.split('/').pop() }
      setSelectedCombination(obj);
    } catch (err) {
      console.error(err);
      displayMessage("danger", "Error", "Error occured while fetching details");
    }

  }

    const customStyles = {
      menu: (provided) => ({
        ...provided,
        zIndex: 100,
      }),
    };

   

  return (
    <>
      <Breadcrumb List={[{ path: "/Dashboard", name: "Dasboard" }, { path: "/ManageWorkflow", name: "Workflow" }, { path: "#", name: state?.workflow?.workflow_name }]} />
      <div className="mycontainer manage-workflow-box">
        <div className="createworkflowsection1">
          <div className="row">
            <div className="col-md-9 col-sm-12 col-xs-12">
              <h4>Workflow : {state?.workflow?.workflow_name}</h4>
              <p>Workflow reports</p>
            </div>
            <div className="col-md-3 col-sm-12 col-xs-12">
              <center>
                <button type="button" onClick={() => { setShowWFDetailsModal(true) }} className="btn btn-primary btn-wf-detail">Workflow Details</button>
              </center>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-sm-12 col-xs-12">
              <div className="form-group1">
                <label>
                  Select Combination
                </label>
                {/* <Select
                      key="combinations"
                      id="combinations"
                      options={{ label: 'NA', value: 'NA' }}
                      onChange={handleChangeCombinations}
                      defaultValue={{ label: 'NA', value: 'NA' }}
                      classNames="'form-control'"
                      styles=""
                    /> */}
                <Select
                  closeMenuOnSelect={true}
                  onChange={combinationSelectChangeHandler}
                  formatOptionLabel={formatOptionLabel}
                  isSearchable
                  options={options}
                  styles={customStyles}
                />
              </div>
            </div>
          </div>
        </div>
        <MenuProvider>
          <WorkflowReportMenu Product={selectedCombination.product} Location={selectedCombination.location} Workflow={state?.workflow} />
        </MenuProvider>
      </div>
      {showWFDetailsModal && createPortal(
        <DetailsPopup onClose={() => setShowWFDetailsModal(false)} workflowData={state?.workflow} />,
        document.body
      )}
    </>
  )
}

export default WorkflowDetails;
